import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";

import { appRoutes, externalRoutes } from "routes";
import logo from "assets/images/common/logo.png";
import twitterLogo from "assets/images/common/twitter.png";
import facebookLogo from "assets/images/common/facebook.png";
import instagramLogo from "assets/images/common/instagram.png";
import pinterestLogo from "assets/images/common/pinterest.png";
import youtubeLogo from "assets/images/common/youtube.png";
import ResponsiveImage from "components/ResponsiveImage";

import CaliforniaDataLink from "./components/CaliforniaDataLink";
import useStyles from "./useStyles";

const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <Link to={appRoutes.rootPath()}>
          <ResponsiveImage src={logo} alt="JibJab" className={classes.logo} width={98} height={90} widthMobile={98} />
        </Link>

        <nav className={classes.nav}>
          <a className={classes.navLink} href={externalRoutes.aboutPath()} target="_blank" rel="noreferrer">
            About
          </a>
          <a className={classes.navLink} href={externalRoutes.helpPath()} target="_blank" rel="noreferrer">
            Help
          </a>
          <Link className={classes.navLink} to={appRoutes.termsOfServicePath()}>
            Terms
          </Link>
          <Link className={classes.navLink} to={appRoutes.privacyPath()}>
            Privacy
          </Link>
        </nav>

        <nav className={classes.social}>
          <a href={externalRoutes.twitterPath()} target="_blank" rel="noreferrer">
            <ResponsiveImage
              className={classes.socialLogo}
              src={twitterLogo}
              alt="JibJab Twitter"
              width={32}
              widthMobile={32}
            />
          </a>
          <a href={externalRoutes.facebookPath()} target="_blank" rel="noreferrer">
            <ResponsiveImage
              className={classes.socialLogo}
              src={facebookLogo}
              alt="JibJab Facebook"
              width={32}
              widthMobile={32}
            />
          </a>
          <a href={externalRoutes.instagramPath()} target="_blank" rel="noreferrer">
            <ResponsiveImage
              className={classes.socialLogo}
              src={instagramLogo}
              alt="JibJab Instagram"
              width={32}
              widthMobile={32}
            />
          </a>
          <a href={externalRoutes.pinterestPath()} target="_blank" rel="noreferrer">
            <ResponsiveImage
              className={classes.socialLogo}
              src={pinterestLogo}
              alt="JibJab Pinterset"
              width={32}
              widthMobile={32}
            />
          </a>
          <a href={externalRoutes.youtubePath()} target="_blank" rel="noreferrer">
            <ResponsiveImage
              className={classes.socialLogo}
              src={youtubeLogo}
              alt="JibJab Youtube"
              width={32}
              widthMobile={32}
            />
          </a>
        </nav>
      </div>

      <CaliforniaDataLink />

      <Typography className={classes.copyright}>
        JibJab®, Sendables®, Starring You® and JokeBox® are registered trademarks of JibJab Catapult CA LLC. © Copyright
        1999–{new Date().getFullYear()} JibJab Catapult CA LLC. All Rights Reserved.
      </Typography>
    </div>
  );
};

export default Footer;
